import Axios from 'axios';
const baseUrl = document.getElementById('baseUrl').value;

export const Ingreso = (pDatos) => Axios.post(`${baseUrl}Home/Ingreso`, { ...pDatos });

export const Menu_Por_Usuario = () => Axios.get(`${baseUrl}Home/Menu_Por_Usuario`, {});

export const ValidarTipoSite = () => Axios.get(`${baseUrl}Home/ValidarTipoSite`, {});

export const DebeOcultarCamposRFC = () => Axios.get(`${baseUrl}Home/DebeOcultarCamposRFC`, {});

export const Sucursal_Lista = () => Axios.get(`${baseUrl}Home/Sucursal_Lista`, {});

export const Sucursal_ListaFiltro = (pNombre) => Axios.get(`${baseUrl}Home/Sucursal_ListaFiltro`, { params: { pNombre: pNombre } });

export const Sucursal_Fiscal_Liskey = (pNombre) => Axios.get(`${baseUrl}Home/Sucursal_Fiscal_Liskey`, { params: { pNombre: pNombre } });

export const ParametroSucursal_Listkey = (pDatos) => Axios.get(`${baseUrl}Home/ParametroSucursal_Listkey`, { params: { ...pDatos } });

export const ParametroSucursal_GuardarCFDI = (pDatos) => Axios.post(`${baseUrl}Home/ParametroSucursal_GuardarCFDI`, { pDatos: JSON.stringify(pDatos) });

export const ParametroCadena_Listkey = () => Axios.get(`${baseUrl}Home/ParametroCadena_Listkey`, {});

export const ParametroCadena_GuardarCFDI = (pDatos) => Axios.post(`${baseUrl}Home/ParametroCadena_GuardarCFDI`, { pDatos: JSON.stringify(pDatos) });

export const ParametroCadena_GuardarCFDI_Logo = (pDatos, config) => Axios.post(`${baseUrl}Home/ParametrosCadena_GuardarCFDI_Logo`, pDatos, config );

export const Cliente_Fiscal_Liskey = (pDatos) => Axios.get(`${baseUrl}Home/Cliente_Fiscal_Liskey`, { params: { ...pDatos } });

export const SAT_UsoCFDI_Lista = () => Axios.get(`${baseUrl}Home/SAT_UsoCFDI_Lista`, {});

export const SAT_MotivoCancelacion_ListaFiltro_TipoFactura = (pClave) => Axios.get(`${baseUrl}Home/SAT_MotivoCancelacion_ListaFiltro_TipoFactura`, { params: { pClave: pClave } });

export const SAT_RegimenFiscal_ListaALL = () => Axios.get(`${baseUrl}Home/SAT_RegimenFiscal_Lista`, {});

export const SAT_RegimenFiscal_Lista = (pClave) => Axios.get(`${baseUrl}Home/Cliente_Fiscal_Regimen_X_Uso_CFDI_List`, { params: { pClave: pClave } });

export const SAT_RegimenFiscal_Lista2 = (pClave) => Axios.get(`${baseUrl}Home/Cliente_Fiscal_Regimen_X_Uso_CFDI_List2`, { params: { pClave: pClave } });

export const SAT_MotivoCancelacion_Lista = () => Axios.get(`${baseUrl}Home/SAT_MotivoCancelacion_Lista`, {});
export const SAT_UsoCFDI = (pRegimen) => Axios.get(`${baseUrl}Home/SAT_UsoCFDIUso`, { params: { pRegimen: pRegimen} });

export const Cadena_Listkey = () => Axios.get(`${baseUrl}Home/Cadena_Listkey`, {});

export const CadenaImagenFS_ListKey_GetImage = () => Axios.get(`${baseUrl}Home/CadenaImagenFS_ListKey_GetImage`, {});

export const Pais_Lista = () => Axios.get(`${baseUrl}Home/Pais_Lista`, {});

export const Nivel1_Lista = () => Axios.get(`${baseUrl}Home/Nivel1_Lista`, {});

export const Nivel2_Lista = (pNivel1) => Axios.get(`${baseUrl}Home/Nivel2_Lista`, { params: { pNivel1 } });

export const Nivel3_Lista = (pNivel1, pNivel2) => Axios.get(`${baseUrl}Home/Nivel3_Lista`, { params: { pNivel1, pNivel2 } });

export const Nivel3_ListaCodPostalAsociado = (pCodigoPostal) => Axios.get(`${baseUrl}Home/Nivel3_ListaCodPostalAsociado`, { params: { pCodigoPostal } });

export const ClienteFiscal_Insert = (pCliente) => Axios.post(`${baseUrl}Home/ClienteFiscal_Insert`, { pCliente: JSON.stringify(pCliente)  });

export const ClienteFiscal_Update = (pCliente) => Axios.post(`${baseUrl}Home/ClienteFiscal_Update`, { pCliente: JSON.stringify(pCliente) });

export const Factura_Contado_Transaccion = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Contado_Transaccion`, { params: { ...pDatos } });

export const Factura_Contado_Consultar_Transaccion = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Contado_Consultar_Transaccion`, { params: { ...pDatos } });

export const Factura_Contado_Consultar_Folio = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Contado_Consultar_Folio`, { params: { ...pDatos } });

export const Factura_Contado_Consultar = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Contado_Consultar`, { params: { ...pDatos } });
 
export const Factura_Credito_Consultar = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Credito_Consultar`, { params: { ...pDatos } });

export const Factura_Consultar = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Consultar`, { params: { ...pDatos } });

export const Factura_Credito_IndividualSoloUna = (pDatos) => Axios.post(`${baseUrl}Home/Factura_Credito_IndividualSoloUna`, { ...pDatos });

export const Factura_Contado_Individual = (pDatos) => Axios.post(`${baseUrl}Home/Factura_Contado_Individual`, { ...pDatos });

export const Factura_Global = (pDatos) => Axios.post(`${baseUrl}Home/Factura_Global`, { ...pDatos });

export const Factura_Global_Por_Rango_Fecha = (pDatos) => Axios.post(`${baseUrl}Home/Factura_Global_Por_Rango_Fecha`, { pDatos: JSON.stringify(pDatos) });

export const ConsultaFacturaFiscal = (pDatos) => Axios.get(`${baseUrl}Home/ConsultaFacturaFiscal`, { params: { ...pDatos } });

export const ConsultaFacturaFiscalDetalle = (pDatos) => Axios.get(`${baseUrl}Home/ConsultaFacturaFiscalDetalle`, { params: { ...pDatos } });

export const FacturaFiscal_Imprimir = (pDatos) => Axios.get(`${baseUrl}Home/FacturaFiscal_Imprimir`, { params: { ...pDatos } }); 

export const Factura_Fiscal_PDF_Listkey = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Fiscal_PDF_Listkey`, { params: { ...pDatos } });

export const Factura_Fiscal_XML_Listkey = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Fiscal_XML_Listkey`, { params: { ...pDatos } });

export const Cliente_Fiscal_Lista_PorNombre = (pClienteFiscalNombre) => Axios.get(`${baseUrl}Home/Cliente_Fiscal_Lista_PorNombre`, { params: { pClienteFiscalNombre } });

export const Get_Tickets_Credito_Por_Cliente = (pDatos) => Axios.get(`${baseUrl}Home/Get_Tickets_Credito_Por_Cliente`, { params: { ...pDatos  } });

export const Factura_Anulacion_Consultar = (pDatos) => Axios.get(`${baseUrl}Home/Factura_Anulacion_Consultar`, { params: { ...pDatos } });

export const Factura_Anulacion = (pDatos) => Axios.post(`${baseUrl}Home/Factura_Anulacion`, { ...pDatos });

export const Empresa_lista = () => Axios.get(`${baseUrl}Home/Empresa_Lista`, {});

export const Cadena_lista = () => Axios.get(`${baseUrl}Home/Cadena_Lista`, {});

export const Parametros_General_ListKey = () => Axios.get(`${baseUrl}Home/Parametros_General_ListKey`, {});

export const Parametros_Generales_Save = (pDatos) => Axios.post(`${baseUrl}Home/Parametros_Generales_Save`, { parametros: JSON.stringify(pDatos) });

export const Autorizador_Factura_List = () => Axios.get(`${baseUrl}Home/Autorizador_Factura_List`, {});

export const Autorizador_Factura_ListKey = (pId) => Axios.get(`${baseUrl}Home/Autorizador_Factura_ListKey`, { params: { pAutorizador_Id: pId } });

export const Autorizador_Factura_Insert = (pDatos) => Axios.post(`${baseUrl}Home/Autorizador_Factura_Insert`, { pAutorizador: JSON.stringify(pDatos) });

export const Fiscal_Tipo_Global_List = () => Axios.get(`${baseUrl}Home/Fiscal_Tipo_Global_List`, {});

export const Fiscal_Global_Clasificacion_List = () => Axios.get(`${baseUrl}Home/Fiscal_Global_Clasificacion_List`, {});

export const Fiscal_Tipo_Global_ListKey = (pId) => Axios.get(`${baseUrl}Home/Fiscal_Tipo_Global_ListKey`, { params: { pGlobal_Id: pId } });

export const Sucursal_Fiscal_ListKey = (pId) => Axios.get(`${baseUrl}Home/Sucursal_Fiscal_ListKey`, { params: { pFiscal_Id: pId } });

export const Sucursal_fiscal_Insert = (pDatos) => Axios.post(`${baseUrl}Home/Sucursal_Fiscal_Insert`, { pData: JSON.stringify(pDatos) });

export const Forma_De_Pago_List = () => Axios.get(`${baseUrl}Home/Forma_De_Pago_List`, {});

export const GetVersion = () => Axios.get(`${baseUrl}Home/GetVersion`, {});

export const Anular_Factura_Masivo = (pDatos, config) => Axios.post(`${baseUrl}Home/Anular_Factura_Masivo`, pDatos, config);

export const Consulta_Cola_Venta_Credito_Fiscal = (pDatos) => Axios.get(`${baseUrl}Home/Consulta_Cola_Venta_Credito_Fiscal`, { params: { ...pDatos } });

export const Aplicar_Cola_Venta_Credito_Fiscal = (pDatos) => Axios.post(`${baseUrl}Home/Aplicar_Cola_Venta_Credito_Fiscal`, { pDatos: JSON.stringify(pDatos) });

export const Aplicar_Todo_Cola_Venta_Credito_Fiscal = () => Axios.get(`${baseUrl}Home/Aplicar_Todo_Cola_Venta_Credito_Fiscal`, {});

export const Consulta_Cancelaciones = (pDatos) => Axios.get(`${baseUrl}Home/Consulta_Cancelaciones`, { params: { ...pDatos } });

export const Consulta_Nota_Credito = (pDatos) => Axios.get(`${baseUrl}Home/Consulta_Nota_Credito`, { params: { ...pDatos } });


// WEBPACK FOOTER //
// ./Public/src/js/request/rfc.js